import React from 'react';

import AgDateFilterLayout from '@/components/AgGrid/components/AgDateFilter/AgDateFilterLayout';

import { AgDateFilterProps } from '@/components/AgGrid/components/AgDateFilter/types';
import useAgDateFilterCore from '@/components/AgGrid/components/AgDateFilter/hooks/useAgDateFilterCore';

const AgDateFilterFE: React.FC<AgDateFilterProps> = ({
  defaultOption,
  model,
  onModelChange,
  format,
  buttons,
  colDef,
}) => {
  const core = useAgDateFilterCore({
    defaultOption,
    model,
    onModelChange,
    field: colDef.field,
  });

  return <AgDateFilterLayout format={format} buttons={buttons} {...core} />;
};

export default AgDateFilterFE;
